/**
 * Converts a textarea string back to Markdown formatted text.
 * - Blank lines (or lines containing only whitespace) are treated as paragraph breaks.
 * - Non-empty lines get a forced line break (two spaces + newline) unless the following line is blank or it's the last line.
 *
 * @param textarea - The raw text from the textarea.
 * @returns A valid Markdown formatted string.
 */
export function textAreaValueToMarkdown(textarea: string): string {
  const lines = textarea.split("\n")
  const markdownLines = lines.map((line, idx, arr) => {
    // Treat lines that are empty or only whitespace as blank.
    if (line.trim() === "") {
      return ""
    }

    const isLastLine = idx === arr.length - 1
    // Check the next line (if any) and consider it blank if it contains only whitespace.
    const nextLine = arr[idx + 1] || ""
    const nextLineIsBlank = nextLine.trim() === ""

    // For non-last lines and when the next line is not blank,
    // we add two trailing spaces to indicate a forced line break in Markdown.
    return !isLastLine && !nextLineIsBlank ? line + "  " : line
  })

  return markdownLines.join("\n")
}
